import type { AppState } from '@/types';

export const selectBackendVersion = (state: AppState) => state.backendVersion;
